import { useEffect } from 'react';
import { useThemeStore } from '@/stores/theme-store';
import { InteractiveBackground } from '@/components/ui/interactive-background';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
    const { theme } = useThemeStore();

    // Apply theme to document
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);

    return (
        <>
            <InteractiveBackground />
            {children}
        </>
    );
}
